import Button from "components/BaseWidgets/button";
import ActiveSessionCard from "../ActiveSessionCard";
import CardLayout from "components/Settings/components/CardLayout";
import ActionModal from "components/Settings/components/ActionModal";
import { useState } from "react";
import { LogoutIconCircle } from "assets/icons";
import { useclearSession } from "hooks/api/useSettings";
import { useQueryClient } from "@tanstack/react-query";
import EmptyState from "components/BaseWidgets/emptyState";

function ActiveSessions({ activeSessionData }) {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);

  const { mutate: clearSession } = useclearSession({
    onSuccess: () => {
      setOpen(false);
      queryClient.invalidateQueries({ queryKey: ["SessionSettings"] });
    },
  });

  const handleClearAllSessions = () => {
    clearSession({});
  };

  return (
    <CardLayout
      className="active-session-container"
      title="Active sessions"
      extraContent={
        <>
          {activeSessionData.length != 0 && (
            <Button
              className="forgot-password-btn"
              variant="link"
              onClick={() => setOpen(true)}
            >
              Log out of all devices
            </Button>
          )}

          <ActionModal
            title="Log out of all devices?"
            description="This will log you out from every active session. You’ll need to sign in again to continue."
            open={open}
            setOpen={setOpen}
            footer={{
              left: { label: "Cancel", action: () => setOpen(false) },
              right: { label: "Logout All", action: handleClearAllSessions },
            }}
            icon={<LogoutIconCircle />}
          />
        </>
      }
    >
      <div className="flex flex-col gap-4">
        {activeSessionData.length > 0 ? (
          activeSessionData.map((item, i) => (
            <ActiveSessionCard key={i} data={item} />
          ))
        ) : (
          <EmptyState message="No active sessions" />
        )}
      </div>
    </CardLayout>
  );
}

export default ActiveSessions;
